import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { Add, Upload } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { usePagesContext } from 'modules/pages/lib/hooks/usePagesContext'

interface FolderEmptyStateProps {
  handleCreatePage: () => void
  handleImportPDF: () => void
}
export const FolderEmptyState = ({ handleCreatePage, handleImportPDF }: FolderEmptyStateProps) => {
  const { canEditPages } = usePagesContext()
  return (
    <Box height="full" alignItems="center" justifyContent="center">
      <OneEmptyState
        description={
          canEditPages
            ? i18n.t('pages.folder.empty_state.description_edit')
            : i18n.t('pages.folder.empty_state.description_view')
        }
        title={i18n.t('pages.folder.empty_state.title')}
        emoji={'📂'}
        actions={
          canEditPages
            ? [
                {
                  label: i18n.t('pages.folder.empty_state.import_pdf'),
                  onClick: () => handleImportPDF(),
                  icon: Upload,
                  variant: 'outline',
                },
                {
                  label: i18n.t('pages.folder.empty_state.new_page'),
                  onClick: () => handleCreatePage(),
                  icon: Add,
                },
              ]
            : []
        }
      />
    </Box>
  )
}
